import React, { ReactElement } from 'react';
import { TextInputField } from '@bucketplace/commerce-admin-ui';

import { FormContent, InspectorFormProvider } from '../../../components';
import { DocumentInspectorProps } from '../../../types';
import { TextTabItemProps } from './TextTabItem';

export function TextTabItemInspector({
  value,
  onChange,
}: DocumentInspectorProps<TextTabItemProps>): ReactElement {
  return (
    <InspectorFormProvider value={value} onChange={onChange}>
      <FormContent
        header="탭 타이틀"
        required
      >
        <TextInputField
          name="text"
          width="100%"
          hint="최대 10자까지 입력 가능합니다."
          rules={{
            required: true,
            validate: (value) => {
              if (value.trim() === '') {
                return false;
              }

              if (value.length > 10) {
                return '최대 10자까지 입력 가능합니다.';
              }

              return true;
            },
          }}
        />
      </FormContent>
    </InspectorFormProvider>
  );
}
